import React from "react";
import Fetch from "react-fetch-component";
import StateContext from "../contexts/State";

const url = `https://www.gabrielleaapri.com/.netlify/functions/social-proof?product=${
  window.SOCIAL_PROOF_PRODUCT
}`;

const OrdersRequest = ({ actions }) => (
  <Fetch url={url} options={{ mode: "cors" }}>
    {({ loading, error, data }) => {
      actions.updateOrders(loading, error, data);
      return null;
    }}
  </Fetch>
);

const OrdersRequestContainer = () => (
  <StateContext.Consumer>
    {({ actions }) => <OrdersRequest actions={actions} />}
  </StateContext.Consumer>
);

export default OrdersRequestContainer;
